@if (isSortOpen) {
  <div class="overlay" (click)="toggleModal()"></div>
  <div class="sort-container">
    <div
      class="sort-item"
      *ngFor="let item of sortingTypeDictionary"
      (click)="toggleModal(item)"
    >
      <div class="icon">
        <img alt="Ascending Sort"
          *ngIf="item === 'ASCENDING'"
          src="assets/core/sort/ascending.svg"
        />
        <img alt="Descending Sort"
          *ngIf="item === 'DESCENDING'"
          src="assets/core/sort/descending.svg"
        />
      </div>
      <div class="text">
        <span>{{ item | translate }}</span>
      </div>
    </div>
  </div>
}
<div class="button-wrapper">
  <div class="button" (click)="toggleModal()">
    <div class="button-text">
      <span>{{ "SORTBY" | translate }}</span>
    </div>
    <div class="sort-type">
      <span>{{ selectedOption! | translate }}</span>
    </div>
    <div><img alt="Sort" src="assets/core/table-button/sort.svg" /></div>
  </div>
</div>
